import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { loginWithToken } = useApp();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      toast.error("Missing Google session");
      nav("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        loginWithToken(data.token, data.user);
        // Clear hash so refresh doesn't re-trigger
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        toast.success(`Welcome, ${data.user.name || "friend"}`);
        nav("/", { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || "Google sign-in failed");
        nav("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="auth-callback" className="min-h-[60vh] flex flex-col items-center justify-center text-center">
      <Loader2 className="h-8 w-8 text-blue-400 animate-spin mb-4"/>
      <p className="font-display text-lg">Signing you in with Google…</p>
      <p className="text-sm text-white/50 mt-1">One moment please.</p>
    </div>
  );
}
